import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
const routes=[
  {
    path: '/',
    name:'Layout',
    component:() => import('../layout.vue'),
    redirect:{name:'blank'},
    children:[
      {
        path:"/blank",
        name:"blank",
        component: () => import('../views/blank/blank.vue')
      },
      {
        path:"/index0",
        name:"index0",
        component: () => import('../views/index0/index0.vue')
      },
      {
        path:"/index1",
        name:"index1",
        component: () => import('../views/index1/index1.vue')
      },
      {
        path:"/index2",
        name:"index2",
        component: () => import('../views/index2/index2.vue')
      },
      {
        path:"/index10",
        name:"index10",
        component: () => import('../views/index10/index10.vue')
      },
      {
        path:"/ysxy",
        name:"ysxy",
        component: () => import('../views/ysxy/ysxy.vue')
      },
      {
        path:"/yhxy",
        name:"yhxy",
        component: () => import('../views/yhxy/yhxy.vue')
      },
      {
        path:"/index3",
        name:"index3",
        component: () => import('../views/index3/index3.vue')
      },
      {
        path:"/index4",
        name:"index4",
        component: () => import('../views/index4/index4.vue')
      },
      {
        path:"/index5",
        name:"index5",
        component: () => import('../views/index5/index5.vue')
      },
      {
        path:"/index6",
        name:"index6",
        component: () => import('../views/index6/index6.vue')
      },
      // 说事详情&书记交办详情
      {
        path: "/index7",
        name: "index7",
        component: () => import("../views/index7/index7.vue"),
      },
      // 乡村治理
      {
        path: "/index8",
        name: "index8",
        component: () => import("../views/index8/index8.vue"),
      },
    ]
  },
]

const router = new VueRouter({
  routes
})
// 路由拦截
router.beforeEach((to,from,next) =>{
    next()
})
export default router




// WEBPACK FOOTER //
// ./src/router/index.js